import React, { useState } from 'react'
import {
  Autocomplete,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  DialogContent,
  Select,
  MenuItem,
} from '@mui/material'
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material/'
import {
  TEAM_SUB_TYPES,
  TEAM_TYPES,
  TOAST_SETTINGS,
  TOAST_SETTINGS_ERROR,
} from '../../../utility/constants'
import { adminTeamsService } from '../../../services/admin/teams'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { toast } from 'react-toastify'

const defaultValue = {
  name: '',
  team_type: null,
  team_subtype: null,
  company_id: '',
}

const AddEditTeamDialog = ({
  teams,
  isOpen,
  setCloseOpen,
  fetchFreshList = () => {},
  allTypes = [],
  allSubTypes = [],
}) => {
  const { user } = useAuthContext()
  const [selectedTeam, setSelectedTeam] = useState(null)
  const [teamDetails, setTeamDetails] = useState({})

  const addEditTeam = async () => {
    let payload = {
      ...teamDetails,
      is_all_assignments: false,
      company_id: user.company_id,
    }

    if (selectedTeam == null) {
      payload.team_id = -1
    } else {
      payload.team_id = selectedTeam.id
    }

    if (!payload?.name || payload?.name?.length < 3) {
      toast.error('Team name should be at least 3 characters long.', TOAST_SETTINGS_ERROR)
      return
    }

    if (!payload?.team_type || payload?.team_type == null) {
      toast.error('Please select team type.', TOAST_SETTINGS_ERROR)
      return
    }

    try {
      await adminTeamsService.addEditTeam(user, payload)
      toast.success('Saved successfully!', TOAST_SETTINGS)
      setTeamDetails(defaultValue)
      setSelectedTeam(null)
      setCloseOpen(false)
      fetchFreshList()
    } catch (error) {
      toast.error('Something went wrong!.', TOAST_SETTINGS_ERROR)
    }
  }

  return (
    <Dialog open={isOpen} onClose={() => setCloseOpen(false)}>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h5">{selectedTeam == null ? 'Add Team' : 'Edit Team'}</Typography>
          <IconButton align="right" onClick={() => setCloseOpen(false)} size="small">
            <HighlightOffIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          style={{ marginTop: 0 }}
          value={selectedTeam}
          size="small"
          options={teams}
          getOptionLabel={(it) => it.name}
          renderInput={(params) => <TextField {...params} label="Select Team To Edit" />}
          onChange={(_, v) => {
            if (v) {
              setSelectedTeam(v)
              setTeamDetails({
                ...defaultValue,
                name: v.name,
                team_type: v.team_type,
                team_subtype: v.team_subtype,
                company_id: v.company_id,
              })
            } else {
              setSelectedTeam(v)
              setTeamDetails(defaultValue)
            }
          }}
        />
        <TextField
          style={{ marginTop: 16 }}
          fullWidth
          color="primary"
          variant="outlined"
          value={teamDetails.name}
          onChange={(e) =>
            setTeamDetails({
              ...teamDetails,
              name: e.target.value,
            })
          }
          placeholder="Team Name"
          size="small"
        ></TextField>
        <Select
          key={teamDetails.team_type}
          style={{ marginTop: 16 }}
          fullWidth
          label="Team type"
          color="primary"
          size="small"
          value={teamDetails.team_type}
          onChange={(e) =>
            setTeamDetails({
              ...teamDetails,
              team_type: e.target.value,
            })
          }
        >
          {allTypes?.map((it) => {
            return (
              <MenuItem key={it} value={it}>
                {it?.toUpperCase()}
              </MenuItem>
            )
          })}
        </Select>
        <Select
          key={teamDetails.team_subtype}
          style={{ marginTop: 16 }}
          fullWidth
          size="small"
          color="primary"
          label="Team subtype"
          value={teamDetails.team_subtype}
          onChange={(e) =>
            setTeamDetails({
              ...teamDetails,
              team_subtype: e.target.value,
            })
          }
        >
          <MenuItem value={null}>N/A</MenuItem>
          {allSubTypes?.map((it) => {
            return (
              <MenuItem key={it} value={it}>
                {it?.toUpperCase()}
              </MenuItem>
            )
          })}
        </Select>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Button
            color="primary"
            variant="contained"
            type="button"
            size="small"
            onClick={addEditTeam}
          >
            {selectedTeam == null ? 'Create Team' : 'Update Team Details'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default AddEditTeamDialog
